export default __webpack_public_path__ + "static/media/time-picker.27508af9.svg";